import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useOktaAuth } from "@okta/okta-react";

export const PrivateRoute = () => {    
    const { authState } = useOktaAuth();

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return authState !== null && authState.isAuthenticated === true ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;